<div id="dialog-container" #form>
  <header>
    <div class="title">
      {{title | translate}}
      <h6 *ngIf="clickedOutside" style="color:red;margin:auto">
        <asp-icon name="ic-20-feedback-alert-error.svg" width="1rem"></asp-icon>
        {{'servicePersonnel.alertCancleMessage'| translate}}</h6>
    </div>

    <div class="close-icon" (click)="close()">
      <asp-icon name="ic-20-utility-close-default.svg"></asp-icon>
    </div>
  </header>
  <section class="body" [ngStyle]="{'height': data.type === 'shift'?  '18.875rem' : '6.875rem'}">
    <form [formGroup]="itemForm" class="item-form">
      <div class="row data-row">
        <div class="col-md-12" style="padding: 0px;">
          <div>{{ 'servicePersonnel.name' | translate }}</div>
          <mat-form-field appearance="outline" class="add-item-inputfield">
            <input matInput placeholder="{{'scheduleRotation.enterName' | translate}}" formControlName='name'>
            <mat-error *ngIf="itemForm?.controls?.name?.errors?.required" [innerHTML]="'scheduleRotation.nameIsRequired' | translate">
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row data-row" *ngIf="data.type === 'shift'">
        <div class="col-md-12">
          <div class="label">{{'scheduleRotation.startTime' | translate}}</div>
          <mat-form-field appearance="outline">
            <input matInput type="time" id="appt1" name="appt1" placeholder="{{ 'servicePersonnel.chooseATime' | translate }}" formControlName='fromTime'>
            <mat-error *ngIf="itemForm.controls.fromTime.hasError('required')" [innerHTML]="'scheduleRotation.timeIsRequired' | translate">
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row data-row" *ngIf="data.type === 'shift'">
        <div class="col-md-12">
          <div class="label">{{'scheduleRotation.endTime' | translate}}</div>
          <mat-form-field appearance="outline">
            <input matInput type="time" [min]="itemForm.controls.fromTime.value"
                   id="appt" name="appt" placeholder="{{ 'servicePersonnel.chooseATime' | translate }}"
                   formControlName='toTime'>
            <mat-error *ngIf="itemForm.controls.toTime.hasError('required')" [innerHTML]="'scheduleRotation.timeIsRequired' | translate">
            </mat-error>
          </mat-form-field>
        </div>
      </div>

    </form>
  </section>

  <div class="add-button" style="width: 100%;margin-left: 3rem;">
    <button class="asp-btn asp-btn-primary save-button"
    (click)="onActionClicked()"
    [disabled]="!itemForm.valid"
    [ngClass]="{'asp-btn-disabled' : !itemForm.valid}" >
      <span>{{actionText | translate}}</span>
    </button>
  </div>
    <footer>
      <div style="width: 80%;">
        <button class="asp-btn asp-btn-secondary cancel-button" (click)="close()">
          <span>{{ 'scheduleRotation.cancel' | translate }}</span>
        </button>
      </div>
  </footer>
</div>
